import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { useFlagcardContext } from 'app/contexts/flagcard'
import { ValidationError } from 'app/shared/types'
import MainLayout from 'layouts/main'
import partOfSpeechsService, {
  PartOfSpeech,
  UpdatePartOfSpeechRequest,
} from 'services/http/dataset/part-of-speech'

import { UpdatePartOfSpeechProps } from './types'
import PartOfSpeechForm from './PartOfSpeechForm'

const UpdatePartOfSpeech: React.FunctionComponent<UpdatePartOfSpeechProps> = ({
  match,
  history,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isReady, setIsReady] = useState(true)
  const [partOfSpeech, setPartOfSpeech] = useState<PartOfSpeech>()
  const [flagcard] = useFlagcardContext()

  useEffect(() => {
    const id = parseInt(match.params.id)

    partOfSpeechsService
      .getById(id)
      .then((res) => {
        setPartOfSpeech(res.data)
      })
      .catch((err: Error) => {
        console.log(err)
      })
      .finally(() => {
        setIsReady(false)
      })
  }, [match.params.id, history])

  const handleSubmit = (data: UpdatePartOfSpeechRequest) => {
    if (data) {
      setIsLoading(true)

      partOfSpeechsService
        .update(data)
        .then(() => {
          flagcard.add({
            id: uid(),
            appearance: 'success',
            title: 'İşlem Başarılı',
            children:
              'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
          })
        })
        .catch((error) => {
          console.log(error)

          flagcard.add({
            id: uid(),
            appearance: 'error',
            title: 'Hata Oluştu',
            children:
              'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
          })
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  const handleError = (error?: ValidationError) => {
    console.log(error)
  }

  const breadcrumbs = (
    <Breadcrumb>
      <BreadcrumbItem text="Anasayfa" href="/" />
      <BreadcrumbItem text="Kelime parçaları" href="/part-of-speech" />
      <BreadcrumbItem text="Kelime parçası güncelle" />
    </Breadcrumb>
  )

  return (
    <MainLayout isLoading={isReady}>
      <Container width="medium">
        <Page>
          <PageHeader
            // actions={<Button appearance="error">Delete user</Button>}
            breadcrumbs={breadcrumbs}
            bottomBar={
              <p>
                Aşağıdaki bilgileri doldurarak geçerli kelime parçalarını
                güncelleyebilirsiniz.
              </p>
            }
          >
            Veri güncelleniyor: {partOfSpeech ? partOfSpeech.name : null}
          </PageHeader>
          <PartOfSpeechForm
            actions={
              <ButtonGroup>
                <Button
                  appearance="primary"
                  children="Güncelle"
                  isLoading={isLoading}
                  type="submit"
                />
                <LinkButton href="/part-of-speech">İptal</LinkButton>
              </ButtonGroup>
            }
            operation="update"
            onSubmit={handleSubmit}
            onError={handleError}
            values={partOfSpeech}
          />
        </Page>
      </Container>
    </MainLayout>
  )
}

export default UpdatePartOfSpeech
